// extracted by mini-css-extract-plugin
export default {"background":"Home_background__HCAG+","content":"Home_content__hLcIA","container":"Home_container__-0Q1b","button":"Home_button__hJpBz"};